export enum RadixAppearance {
  Light = 'light',
  Dark = 'dark',
  Inherit = 'inherit',
}

export type RadixTextAlign = 'left' | 'center' | 'right';

export type RadixSide = 'top' | 'bottom' | 'left' | 'right';

export type RadixBtnSize = '1' | '2' | '3' | '4';

export type RadixAvatarSize =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9';

export type RadixTextSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';

export type RadixTextFieldSize = '1' | '2' | '3';

export type RadixCalloutSize = '1' | '2' | '3';

export type RadixCalloutVariant = 'soft' | 'surface' | 'outline';

export type RadixContainerSize = '1' | '2' | '3' | '4';

export type RadixSelectVariant = 'classic' | 'soft' | 'surface' | 'ghost';

export type RadixFlexAlign =
  | 'start'
  | 'center'
  | 'end'
  | 'baseline'
  | 'stretch';

export type RadixFlexJustify = 'start' | 'center' | 'end' | 'between';

export type RadixGridColumn =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9';

export type RadixFlexGap =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9';

export type RadixBtnVariant =
  | 'classic'
  | 'solid'
  | 'soft'
  | 'surface'
  | 'outline'
  | 'ghost';

export type RadixColor =
  | 'amber'
  | 'blue'
  | 'bronze'
  | 'brown'
  | 'crimson'
  | 'cyan'
  | 'gold'
  | 'grass'
  | 'gray'
  | 'green'
  | 'indigo'
  | 'iris'
  | 'jade'
  | 'lime'
  | 'mint'
  | 'orange'
  | 'pink'
  | 'plum'
  | 'purple'
  | 'red'
  | 'ruby'
  | 'sky'
  | 'teal'
  | 'tomato'
  | 'violet'
  | 'yellow';

export type RadixTextType =
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'hidden'
  | 'month'
  | 'number'
  | 'password'
  | 'search'
  | 'tel'
  | 'text'
  | 'time'
  | 'url';

interface RadixConstants {
  CLR: {
    ADMIN: RadixColor;
    DEALER: RadixColor;
    USER: RadixColor;

    SUCCESS: RadixColor;
    INFO: RadixColor;
    WARNING: RadixColor;
    DANGER: RadixColor;
    NEUTRAL: RadixColor;

    HIGHLIGHT: RadixColor;
  };
}

export const RX: RadixConstants = {
  CLR: {
    ADMIN: 'pink',
    DEALER: 'teal',
    USER: 'indigo',

    SUCCESS: 'green',
    INFO: 'blue',
    WARNING: 'yellow',
    DANGER: 'red',
    NEUTRAL: 'gray',

    HIGHLIGHT: 'mint',
  },
};
